if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        nextButton: this.querySelector('[data-button-gallery-next]'),
        prevButton: this.querySelector('[data-button-gallery-prev]'),
        dots: this.querySelector('[data-slider-dots]'),
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.bindButtonEvents();

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.viewer.addEventListener('slideChanged', this.onSlideChangedChangeVector.bind(this));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout !== 'stacked' && this.mql.matches) this.removeListSemantic();
    }

    bindButtonEvents() {
      if (this.elements.nextButton) {
        this.elements.nextButton.addEventListener('click', this.changeSlide.bind(this, 'next'));
      }
      if (this.elements.prevButton) {
        this.elements.prevButton.addEventListener('click', this.changeSlide.bind(this, 'prev'));
      }
    }

    changeSlide(type) {
      if (!type) {
        console.error('No type set in function please set prev or next');
        return;
      }
      const activeSlide = this.querySelector('.slider__slide.is-active');
      if (!activeSlide) {
        console.error('No active slide found, please check configuration');
        return;
      }
      const dataMediaId = activeSlide.dataset.mediaId;
      const thumbnailsItems = this.elements.thumbnails.querySelectorAll('[data-target]');
      let activeMediaIndex = null;
      const thumbnailsItemsLength = thumbnailsItems.length;
      for (let i=0; i<thumbnailsItemsLength; i++) {
        if (thumbnailsItems[i].dataset.target == dataMediaId) {
          activeMediaIndex = i;
          break;
        }
      }

      if (activeMediaIndex == null) {
        console.error('No active media index found, please check configuration');
        return;
      }
      if ((activeMediaIndex == 0 && type == 'prev') || (activeMediaIndex == thumbnailsItemsLength && type == 'next')) {
        return;
      }
      if (type == 'next') {
        activeMediaIndex++;
      }
      if (type == 'prev') {
        activeMediaIndex--;
      }

      this.setActiveMedia(thumbnailsItems[activeMediaIndex].dataset.target, false);
    }

    updateImageInStickyATC(activeThumbnail) {
      if (document.querySelector('.sticky-image')) {
        if(activeThumbnail.querySelector('span.thumbnail__badge') == null) document.querySelector('.sticky-image').innerHTML = activeThumbnail.querySelector('button').innerHTML;
      } 
    }

    onSlideChangedChangeVector(event) {
      this.setBackgroundVector(event.detail.currentElement.dataset.mediaId);
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
      if (this.elements.dots) {
        const activeDot = this.elements.dots.querySelector(`[data-dot-target="${ event.detail.currentElement.dataset.mediaId }"]`);
        this.setActiveDot(activeDot);
      }
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.setBackgroundVector(mediaId);

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.updateImageInStickyATC(activeThumbnail);
      let activeDot = null;
      if (this.elements.dots) {
        activeDot = this.elements.dots.querySelector(`[data-dot-target="${ mediaId }"]`);
        this.setActiveDot(activeDot);
      }

      this.elements.prevButton.classList.remove('not-visible');
      this.elements.nextButton.classList.remove('not-visible');
      if (activeDot && activeDot.dataset.mediaPosition == 0) {
        this.elements.prevButton.classList.add('not-visible');
        this.elements.nextButton.classList.remove('not-visible');
      }
      if (activeDot && activeDot.dataset.mediaPosition == (this.elements.dots.children.length-1)) {
        this.elements.prevButton.classList.remove('not-visible');
        this.elements.nextButton.classList.add('not-visible');
      }

      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    setActiveDot(dot) {
      if (!this.elements.dots || !dot) return;

      this.elements.dots.querySelectorAll('li').forEach((element) => element.classList.remove('active'));
      dot.classList.add('active');
    }

    setBackgroundVector(mediaId) {
      const data = document.querySelector('[data-vector-colors]');
      const vectorBg = document.querySelector(".background-vector");
      if (!vectorBg || !data) return;
      
      const values = JSON.parse(data.innerHTML);
      const mediaSplit = mediaId.split('-');
      const searchedId = mediaSplit[mediaSplit.length-1];
      let searchedData = values.find((value) => value.media_id == parseInt(searchedId));
      const defaultData = values.find((value) => value.default == true);

      if (!searchedData) {
        if (!defaultData) return;
        searchedData = defaultData;
      }
      if (!searchedData.vector_color1 || !searchedData.vector_color2) {
        if (!defaultData || !defaultData.vector_color1 || !defaultData.vector_color2) return;
          searchedData.vector_color1 = defaultData.vector_color1;
          searchedData.vector_color2 = defaultData.vector_color2;
      }

      const stops1 = vectorBg.querySelectorAll('.stop1');
      const stops2 = vectorBg.querySelectorAll('.stop2');
      stops1.forEach((stop) => {
        stop.setAttribute('stop-color', searchedData.vector_color1);
      });
      stops2.forEach((stop) => {
        stop.setAttribute('stop-color', searchedData.vector_color2);
      });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
